import AbstractScene from './AbstractScene.js';
import ControllButton from '../prefabs/ControllBoard/ControllButton.js';
import ParallaxLayer from '../prefabs/ParallaxLayer.js';
import Player from '../prefabs/Player.js';
import TestSpawner from '../prefabs/obstacles/TestSpawner.js';
import FishSpawner from '../prefabs/poissons/FishSpawner.js';
import Chrono from '../prefabs/Chrono.js';
import { Colors } from '../consts/Colors.js';
import { TextContents } from '../consts/TextContents.js';
import LifeCount from '../prefabs/LifeCount.js';
import ButtonRounded from '../prefabs/buttons/ButtonRounded.js';

import TraductionManager from '../prefabs/TraductionManager.js';

export default class GameTuto extends AbstractScene {
    constructor() {
        super({
            key: 'GameTuto',
        });
        this.parallaxSpeed;
        this.obstacleSpawnDelay;
        this.fishSpawnDelay;
        this.switchLaneDuration;

        this.laneOne;
        this.laneTwo;
        this.laneThree;
        this.laneFour;
        this.laneFive;
    }
    init(data) {
        this._init(data);
        this.traductionManager = new TraductionManager();
        this.parallaxSpeed = 400; // ms
        this.obstacleSpawnDelay = 1400; // ms
        this.fishSpawnDelay = 1200; // ms
        this.switchLaneDuration = 80; // ms

        this.numLanes = 5;
        this.laneSpacing = 90;
        this.turtleHeight = 81 * this.game.data.scaleY;

        const centerY = this.scale.height / 2;

        this.laneOne = centerY - 2 * this.laneSpacing;
        this.laneTwo = centerY - 1 * this.laneSpacing;
        this.laneThree = centerY;
        this.laneFour = centerY + 1 * this.laneSpacing;
        this.laneFive = centerY + 2 * this.laneSpacing;

        // this.laneOne = 80;
        // this.laneTwo = 133;
        // this.laneThree = 186;
        // this.laneFour = 239;
        // this.laneFive = 292;
        // this.turtleLane = 186;

        this.turtleLane = this.laneThree;

        this.testSpawnOK = false;

        this.firstTuto = true;
        this.secondTuto = false;
        this.thirdTuto = false;
        this.fourthTuto = false;
    }

    preload() {
        this._preload();
        this.paraNumber = 10;
        this.spawnerActive = false;

        this.currentLane = 3;
        this.level = this.game.data.level;
        this.errorsCount = this.game.data.errorsCount;
        this.chronoDuration = this.game.data.chronoDuration;
        this.chronoText = this.game.data.chronoText;

        this.upKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.UP);
        this.downKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.DOWN);

        if (this.anims.get('turtleAnim') == undefined) {
            this.createAnimations();
        }
        this.anims.resumeAll();
    }
    update(time, delta) {
        this.parallaxLayerFond.moveParallax(delta);
        this.parallaxLayerPlan1.moveParallax(delta);
        this.parallaxLayerPlan2.moveParallax(delta);
        this.parallaxLayerPlan4.moveParallax(delta);
        this.parallaxLayerBulles.moveParallax(delta);

        if (this.spawnerActive) {
            this.spawner.moveObstacles(delta); // déplacement des obstacles
            if (!this.turtle.isHited) {
                this.checkCollision();
            }
            if (this.testSpawnOK === true) {
                this.changeTutoPopup(this.traductionManager.getText(TextContents.textTuto4.text));

                this.thirdTuto = false;
                this.fourthTuto = true;
                this.addLifeCount();
                this.tutoPopup.setAlpha(1);
                this.spawnerActive = false;
            }
        }
        // if (this.turtle.y === this.laneOne && this.firstTuto === true) {
        //     // console.log('laneOne')
        //     this.firstTuto = false;
        //     this.secondTuto = true;
        //     this.changeTutoPopup(TextContents.textTuto2);
        //     this.tutoPopup.setAlpha(1);

        //     this.animBtnControl(this.downBtn);
        // }
        // if (this.turtle.y === this.laneFive && this.secondTuto === true) {
        //     // console.log('laneFive')
        //     this.secondTuto = false;
        //     this.thirdTuto = true;
        //     this.changeTutoPopup(TextContents.textTuto3);
        //     this.tutoPopup.setAlpha(1);
        // }
    }

    create() {
        this.initParallaxFirst();
        this.turtle = new Player(this, 1000 * this.game.data.scaleX, this.turtleLane, {
            level: this.errorsCount,
            showHitbox: false,
        });
        this.initParallaxSecond();
        this.addControlBoard();
        this.add.tween({
            targets: this.turtle,
            duration: 1500,
            x: 150 * this.game.data.scaleX,
            onComplete: () => {
                this.add.tween({
                    targets: this.controlBoard,
                    duration: 500,
                    alpha: 1,
                    onComplete: () => {
                        this.addTutoPopup();
                    },
                });
            },
        });
    }

    addControlBoard() {
        this.controlBoard = this.add.container(0, 0).setDepth(4).setAlpha(0);
        this.upBtn = new ControllButton(this, 100, 'up');
        this.downBtn = new ControllButton(this, this.width - 100, 'down');
        this.controlBoard.add(this.upBtn);
        this.controlBoard.add(this.downBtn);
    }

    animBtnControl(btn) {
        this.add.tween({
            targets: btn,
            duration: 500,
            scale: 1.5,
            yoyo: true,
            repeat: 2,
        });
    }

    createAnimations() {
        this.anims.create({
            key: 'turtleAnim',
            frames: this.anims.generateFrameNumbers('tortue', { start: 0, end: 10 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'turtleNetAnim',
            frames: this.anims.generateFrameNumbers('tortueNet', {
                start: 0,
                end: 10,
            }),
            frameRate: 11,
            repeat: -1,
        });

        this.anims.create({
            key: 'poissonAnim1',
            frames: this.anims.generateFrameNumbers('poisson1', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim2',
            frames: this.anims.generateFrameNumbers('poisson2', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim3',
            frames: this.anims.generateFrameNumbers('poisson3', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        // this.anims.create({
        //     key: 'poissonAnim4',
        //     frames: this.anims.generateFrameNumbers('poisson4', { start: 0, end: 0 }),
        //     frameRate: 11,
        //     repeat: -1
        // });
        this.anims.create({
            key: 'poissonAnim5',
            frames: this.anims.generateFrameNumbers('poisson5', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim6',
            frames: this.anims.generateFrameNumbers('poisson6', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim7',
            frames: this.anims.generateFrameNumbers('poisson7', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim8',
            frames: this.anims.generateFrameNumbers('poisson8', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim9',
            frames: this.anims.generateFrameNumbers('poisson9', { start: 0, end: 0 }),
            frameRate: 11,
            repeat: -1,
        });
        this.anims.create({
            key: 'poissonAnim10',
            frames: this.anims.generateFrameNumbers('poisson10', {
                start: 0,
                end: 0,
            }),
            frameRate: 11,
            repeat: -1,
        });
    }

    initParallaxFirst() {
        const fondParts = [
            'fond_part1',
            'fond_part2',
            'fond_part3',
            'fond_part4',
            'fond_part5',
            'fond_part6',
            'fond_part7',
            'fond_part8',
            'fond_part9',
        ];
        const plan4Parts = [
            'plan4_part1',
            'plan4_part2',
            'plan4_part3',
            'plan4_part4',
            'plan4_part5',
            'plan4_part6',
            'plan4_part7',
            'plan4_part8',
            'plan4_part9',
        ];
        const plan2Parts = [
            'plan2_part1',
            'plan2_part2',
            'plan2_part3',
            'plan2_part4',
            'plan2_part5',
            'plan2_part6',
            'plan2_part7',
            'plan2_part8',
            'plan2_part9',
        ];

        this.parallaxLayerFond = new ParallaxLayer(this, 0, 0, 300);
        fondParts.forEach((part) => this.parallaxLayerFond.addTexture(part));

        this.parallaxLayerPlan4 = new ParallaxLayer(this, 0, 0, 400);
        plan4Parts.forEach((part) => this.parallaxLayerPlan4.addTexture(part));

        this.parallaxLayerPlan2 = new ParallaxLayer(this, 0, 0, 550);
        plan2Parts.forEach((part) => this.parallaxLayerPlan2.addTexture(part));
    }

    initParallaxSecond() {
        const plan1Parts = [
            'plan1_part1',
            'plan1_part2',
            'plan1_part3',
            'plan1_part4',
            'plan1_part5',
            'plan1_part6',
            'plan1_part7',
            'plan1_part8',
            'plan1_part9',
        ];
        const bullesParts = [
            'bulles_part1',
            'bulles_part2',
            'bulles_part3',
            'bulles_part4',
            'bulles_part5',
            'bulles_part6',
            'bulles_part7',
            'bulles_part8',
            'bulles_part9',
        ];

        this.parallaxLayerPlan1 = new ParallaxLayer(this, 0, 0, 500);
        this.parallaxLayerPlan1.setDepth(4);
        plan1Parts.forEach((part) => this.parallaxLayerPlan1.addTexture(part));

        this.parallaxLayerBulles = new ParallaxLayer(this, 0, -400 * this.game.data.scaleY, 475);
        bullesParts.forEach((part) => this.parallaxLayerBulles.addTexture(part));

        this.tweens.add({
            targets: this.parallaxLayerBulles,
            y: this.parallaxLayerBulles.y + 10,
            duration: 1500,
            repeat: -1,
            yoyo: true,
        });
    }

    turtleMoveUp() {
        if (this.currentLane !== 1) {
            this.add.tween({
                targets: this.turtle,
                duration: this.switchLaneDuration,
                y: this.turtle.y - this.laneSpacing,
                onComplete: () => {
                    this.currentLane = this.currentLane - 1;
                    console.log(TextContents.textTuto2.text);
                    // console.log("this.currentline", this.currentLane)
                    // console.log("this.turtle.y", this.turtle.y)
                    if (this.currentLane === 1 && this.firstTuto) {
                        this.firstTuto = false;
                        this.secondTuto = true;
                        this.changeTutoPopup(
                            this.traductionManager.getText(TextContents.textTuto2.text),
                        );
                        this.tutoPopup.setAlpha(1);
                        this.animBtnControl(this.downBtn);
                    }
                },
            });
        }
    }
    turtleMoveDown() {
        if (this.currentLane !== 5) {
            this.add.tween({
                targets: this.turtle,
                duration: this.switchLaneDuration,
                y: this.turtle.y + this.laneSpacing,
                onComplete: () => {
                    this.currentLane = this.currentLane + 1;
                    console.log('this.currentline', this.currentLane);
                    console.log('this.turtle.y', this.turtle.y);
                    console.log('this.laneFive', this.laneFive);
                    console.log('this.secondTuto', this.secondTuto);
                    if (Math.abs(this.turtle.y - this.laneFive) < 5 && this.secondTuto === true) {
                        // console.log('laneFive')
                        this.secondTuto = false;
                        this.thirdTuto = true;
                        this.changeTutoPopup(
                            this.traductionManager.getText(TextContents.textTuto3.text),
                        );
                        this.tutoPopup.setAlpha(1);
                    }
                },
            });
        }
    }

    checkCollision() {}

    addTutoPopup() {
        this.tutoPopup = this.add.container(0, 0).setDepth(5);
        this.introBackground = this.add
            .rectangle(
                this.width / 2,
                this.height / 2,
                850 * this.game.data.scaleX,
                550 * this.game.data.scaleY,
                Colors.Elmt.White,
            )
            .setOrigin(0.5, 0.5);
        this.tutoPopup.add(this.introBackground);
        let textTuto1 = {
            text: this.traductionManager.getText('textTuto1'),
            config: TextContents.textTuto1.config,
        };
        this.intro = this.createTextElement(
            this.game.data.langue === 'ara' ? this.width / 2 + 320 : this.width / 2,
            this.height / 2,
            textTuto1,
        );
        this.tutoPopup.add(this.intro);
        this.imageTouche = this.add
            .image(
                this.game.data.langue === 'ara'
                    ? 1300 * this.game.data.scaleX
                    : 960 * this.game.data.scaleX,
                this.height / 2 + 10 * this.game.data.scaleY,
                'touchUpOn',
            )
            .setOrigin(0.5, 0.5);

        this.tutoPopup.add(this.imageTouche);
        this.introBtn = this.add.existing(
            new ButtonRounded(
                this,
                this.width / 2,
                this.height / 2 + 250 * this.game.data.scaleY,
                200 * 2 * this.game.data.scaleX,
                96 * 1.5 * this.game.data.scaleY,
                this.traductionManager.getText('btnStart'),
                Colors.Text.White,
                Colors.Elmt.MiddleBlue,
                false,
                Colors.Text.Blue,
                null,
            ),
        );

        this.tutoPopup.add(this.introBtn);
        this.introBtn.setInteractive({ useHandCursor: true });

        this.animBtnControl(this.upBtn);
        this.introBtn.on('pointerout', (e) => {
            this.introBtn.setScale(1);
        });
        this.introBtn.on('pointerover', (e) => {
            this.introBtn.setScale(1.05);
        });
        this.introBtn.on('pointerup', (e) => {
            this.tutoPopup.setAlpha(0);
            if (
                this.firstTuto === true &&
                this.secondTuto === false &&
                this.thirdTuto === false &&
                this.fourthTuto === false
            ) {
                this.upBtn.setActive();
                this.imageTouche.setTexture('touchDownOn');
                this.upKey.on('down', (event) => {
                    this.turtleMoveUp();
                });
            } else if (
                this.firstTuto === false &&
                this.secondTuto === true &&
                this.thirdTuto === false &&
                this.fourthTuto === false
            ) {
                this.imageTouche.setAlpha(0);
                this.downBtn.setActive();
                this.downKey.on('down', (event) => {
                    this.turtleMoveDown();
                });
            } else if (
                this.secondTuto === false &&
                this.thirdTuto === true &&
                this.firstTuto === false &&
                this.fourthTuto === false
            ) {
                this.spawner = new TestSpawner(this, 0, 0, this.obstacleSpawnDelay);
                this.spawnerActive = true;
            } else if (
                this.thirdTuto === false &&
                this.secondTuto === false &&
                this.firstTuto === false &&
                this.fourthTuto === true
            ) {
                this.lifeCount.setEmpty(this.lifeCount.firstLife);
                this.time.addEvent({
                    delay: 2000,
                    callback: () => {
                        this.changeTutoPopup(
                            this.traductionManager.getText(TextContents.textTuto5.text),
                        );
                        this.fourthTuto = false;
                        this.tutoPopup.setAlpha(1);

                        this.chrono = new Chrono(
                            this,
                            this.width - 100,
                            46 * this.game.data.scaleY,
                            this.chronoText,
                            this.chronoDuration,
                        );
                        this.add.tween({
                            targets: this.chrono,
                            duration: 500,
                            scale: 1.2,
                            yoyo: true,
                            repeat: 1,
                        });
                    },
                });
            } else if (
                this.thirdTuto === false &&
                this.secondTuto === false &&
                this.firstTuto === false &&
                this.fourthTuto === false
            ) {
                this.add.tween({
                    targets: this.turtle,
                    duration: 300,
                    y: 598 * 0.36,
                    onComplete: () => {
                        this.scene.start('Game');
                    },
                });
            }
        });
    }

    changeTutoPopup(txt) {
        console.log(txt);
        this.intro.setText(txt);
    }

    addLifeCount() {
        this.lifeCount = new LifeCount(this, this.errorsCount);
        this.add.tween({
            targets: this.lifeCount,
            duration: 500,
            scale: 1.5,
            yoyo: true,
            repeat: 1,
        });
    }
}
